import { render, staticRenderFns } from "./EcReceiveorderTable.vue?vue&type=template&id=4af8d9ce&scoped=true&"
import script from "./EcReceiveorderTable.vue?vue&type=script&lang=js&"
export * from "./EcReceiveorderTable.vue?vue&type=script&lang=js&"
import style0 from "./EcReceiveorderTable.vue?vue&type=style&index=0&id=4af8d9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8d9ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VLayout})
